import { render, staticRenderFns } from "./VariantSifterSettingsPanel.vue?vue&type=template&id=51d06f8e&scoped=true&"
import script from "./VariantSifterSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./VariantSifterSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterSettingsPanel.vue?vue&type=style&index=0&id=51d06f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d06f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d06f8e')) {
      api.createRecord('51d06f8e', component.options)
    } else {
      api.reload('51d06f8e', component.options)
    }
    module.hot.accept("./VariantSifterSettingsPanel.vue?vue&type=template&id=51d06f8e&scoped=true&", function () {
      api.rerender('51d06f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterSettingsPanel.vue"
export default component.exports